import { useAuditApi } from "./common/auditApi";

export function useProductAuditApi() {
  return useAuditApi({
    url: 'product',
    translateTitle: (t) => t.audit.actions.fetchProduct.title,
    translateError: (t) => t.audit.actions.fetchProduct.error
  });
}
